
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/officecubiclequotes/privacy-policy",
      function () {
        return require("private-next-pages/officecubiclequotes/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/officecubiclequotes/privacy-policy"])
      });
    }
  